<template>
  <CModal :title="modalTitle"
          color="danger"
          :show="show"
          :centered="true"
          @update:show="closeModal">

    <div class="content">
      <div class="modal-title">
        <h2>Anchorage Details</h2>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <template v-if="anchorageErrors.length">
        <CAlert v-for="(error, index) in anchorageErrors" :key="`error-${index}`" color="danger" :show="10" closeButton>
          {{ error }}
        </CAlert>
      </template>

      <CRow v-if="anchorage">
        <CCol col="12" class="pr-3">
          <div class="details-row">
            <div class="details-row__title">Id</div>
            <div class="details-row__value">
              {{ anchorage.anchorageId }}
            </div>
          </div>
          <div class="details-row">
            <div class="details-row__title">Name</div>
            <div class="details-row__value">
              <editable-field
                fieldType="text"
                fieldName="anchorageName"
                :entityData="anchorage"
                :saveMethod="updateAnchorage"
                @updated="anchorageUpdated"
                @update-error="anchorageUpdateError"
                placeholder="--" />
            </div>
          </div>
          <div class="details-row">
            <div class="details-row__title">Type</div>
            <div class="details-row__value">
              <editable-field
                fieldType="text"
                fieldName="anchorageType"
                :entityData="anchorage"
                :saveMethod="updateAnchorage"
                @updated="anchorageUpdated"
                @update-error="anchorageUpdateError"
                placeholder="--" />
            </div>
          </div>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="closeModal" color="secondary">Close</CButton>
    </template>
  </CModal>
</template>

<script>
import { mapActions } from 'vuex'
import EditableField from '../../widgets/EditableField'

export default {
  name: 'anchorage-edit-modal',

  components: {
    EditableField,
  },

  props: {
    anchorageId: {
      type: Number,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      anchorage: null,
      anchorageErrors: [],
    };
  },

  methods: {
    ...mapActions(
      'polygons', [
        'getAnchorage',
        'updateAnchorage',
      ],
    ),

    async loadAnchorage() {
      this.loading = true;
      this.anchorage = await this.getAnchorage(this.anchorageId);
      this.loading = false;
    },

    anchorageUpdated(data) {
      this.anchorage = data;
      this.$emit('updated', data);
    },

    anchorageUpdateError(response) {
      this.anchorageErrors = [];
      if(response.error_details) {
        this.anchorageErrors.push(response.error_details);
      } else {
        this.anchorageErrors.push('Unknown anchorage update error');
      }
    },

    closeModal() {
      this.anchorage = null;
      this.$emit('update:show', false);
    },
  },

  computed: {
    modalTitle() {
      if(this.anchorage) {
        return `Anchorage edit: "${this.anchorage.anchorageName}"`;
      } else {
        return `Anchorage edit`;
      }
    },
  },

  watch: {
    async show() {
      await this.loadAnchorage();
    },
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .content {
    padding: 0 10px;
  }

  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }

  .details-row {
    padding-bottom: 5px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted #c60000;

    &__title {
      min-width: 50px;
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__value {
      padding-left: 10px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      /*direction: rtl;*/
      /*text-align: left;*/
    }
  }
</style>
